/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- CHART LEGEND : STYLES --------------- ++++++++++ */
export default {
    chartlegend: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: pxToEm(81),
        // width: pxToEm(234),
        boxShadow: `inset 0px -1px 0px ${themeV2.color.base.gray.light}`,
        marginTop: pxToEm(14),
        padding: `${pxToEm(14)} 0px`,
        '& .container': {
            display: 'flex',
            width: '100%'
        },
        '& .details': {
            width: '100%'
        },
        '& .checkbox': {
            minWidth: pxToEm(16),
            height: pxToEm(16),
            borderRadius: pxToEm(4),
            background: props => props.checkboxColor && props.checked ? props.checkboxColor : '#fff',
            border: props => props.checkboxColor ? `2px solid ${props.checkboxColor}` : `2px solid #000`,
            marginRight: pxToEm(10),
            cursor: 'pointer',
        },
        '& .title': {
            color: props => props.titleColor ? props.titleColor: themeV2.color.base.gray.dark,
            display: 'block'
        },
        '& .valuebadge':{
            display: 'flex',
            justifyContent: 'space-between',
            color: props => props.checked ? themeV2.color.primary.main : themeV2.color.base.gray.dark,
            fontWeight: props => props.checked ? 600 : 500,
            // opacity: props => props.checked ? 1 : 0.5,
            marginTop: pxToEm(12),
            '& .badgechange': {
                display: 'flex',
                alignItems: 'center',
                '& .changetype': {
                    color: themeV2.color.base.gray.dark,
                    fontSize: pxToEm(12),
                    marginLeft: pxToEm(8)
                }
            }
        },
        '& .clickable-true': {
            cursor: 'pointer',
        },
        '& .grayed-true': {
            opacity: 0.4,
        }
    }
};
